
	  <div style="position: relative;" [style.width]="width" [style.height]="height">
		  <div *ngIf="showIncomplete && !profileComplete" class="profileIncomplete"></div>
		<img *ngIf="profilePicExists" [src]="profilePic" alt="Profile picture"
			 class="mugshot" [style.width]="width" [style.height]="height"/>
		<div *ngIf="!profilePicExists" class="profileOrb" #profileOrb
			 [style.background-color]="profileBgColor" [style.color]="profileTextColor" [style.fontSize]="fontSize"
		>{{userInitials}}</div>
	  </div>
  